// Admin calls for invitation codes (backend: routes/signup_routes.py, manage_users).
import axios from 'axios';
import { baseApi } from '../../API/api';
import { authHeaders } from '../../utils/authHeader';

const url = (suffix = '') => `${baseApi}/api/admin/invitations${suffix}`;

/** The backend's message for a failed call. */
export function apiError(error) {
  return error?.response?.data?.error || error?.message || 'Something went wrong.';
}

export async function listInvitations() {
  const { data } = await axios.get(url(), { headers: await authHeaders() });
  return data.invitations || [];
}

export async function createInvitation(email) {
  const { data } = await axios.post(url(), { email }, { headers: await authHeaders() });
  return data.invitation;
}

export async function reissueInvitation(id) {
  const { data } = await axios.post(url(`/${id}/reissue`), {}, { headers: await authHeaders() });
  return data.invitation;
}

export async function revokeInvitation(id) {
  await axios.delete(url(`/${id}`), { headers: await authHeaders() });
}

/** A password reset code for someone who finished sign-up (RDV admins). */
export async function createResetCode(email) {
  const { data } = await axios.post(`${baseApi}/api/admin/reset-codes`, { email }, { headers: await authHeaders() });
  return data.invitation;
}
